import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackLink from "./BackLink";
import "./CategoryPickerPage.css";

export default function CategoryPickerPage({ categories = [] }) {
  const navigate = useNavigate();

  // корни (уровень 1)
  const roots = useMemo(
    () => (categories || []).filter((c) => !c.parent),
    [categories]
  );

  // выбранные узлы по уровням
  const [rootId, setRootId] = useState(null);   // id уровня 1
  const [subId, setSubId]   = useState(null);   // id уровня 2

  const selectedRoot = useMemo(
    () => roots.find((r) => String(r.id) === String(rootId)) || null,
    [roots, rootId]
  );
  const level2 = useMemo(
    () => selectedRoot?.subcategories || [],
    [selectedRoot]
  );

  const selectedSub = useMemo(
    () => level2.find((s) => String(s.id) === String(subId)) || null,
    [level2, subId]
  );
  const level3 = selectedSub?.subcategories || [];

  // обработчики
  const onRootClick = (id) => {
    const root = roots.find((r) => String(r.id) === String(id));
    // если у корня нет детей — это лист, сразу идём в форму
    if (!root?.subcategories?.length) {
      navigate(`/create/${id}`);
      return;
    }
    setRootId(id);
    setSubId(null);
  };

  const onSubClick = (id) => {
    const sub = (selectedRoot?.subcategories || []).find(
      (s) => String(s.id) === String(id)
    );
    // если у 2-го уровня нет детей — это лист, сразу идём в форму
    if (!sub?.subcategories?.length) {
      navigate(`/create/${id}`);
      return;
    }
    setSubId(id);
  };

  const onLeafClick = (id) => {
    // лист — уходим на форму
    navigate(`/create/${id}`);
  };

  return (
    <div className="catpick-wrap">
      {/* шапка с вашей стрелкой назад */}
      <div className="catpick-header">
        <div className="catpick-header-left">
          <BackLink />
        </div>

        <h1 className="catpick-header-center">Επιλογή κατηγορίας</h1>

        <div className="catpick-header-right" />
      </div>

      {/* три колонки как на Avito */}
      <div className="catpick-columns">
        {/* Уровень 1 — корни (всегда видны) */}
        <div className="catpick-col">
          {roots.map((c) => (
            <button
              key={c.id}
              type="button"
              className={`catpick-item ${String(rootId) === String(c.id) ? "is-active" : ""}`}
              onClick={() => onRootClick(c.id)}
            >
              <span className="catpick-name">{c.name}</span>
              <span className="catpick-arrow">›</span>
            </button>
          ))}
        </div>

        {/* Уровень 2 — дети выбранного корня */}
        <div className="catpick-col">
          {level2.map((c) => (
            <button
              key={c.id}
              type="button"
              className={`catpick-item ${String(subId) === String(c.id) ? "is-active" : ""}`}
              onClick={() => onSubClick(c.id)}
              disabled={!rootId} // пока не выбран корень, серый столбец
            >
              <span className="catpick-name">{c.name}</span>
              <span className="catpick-arrow">›</span>
            </button>
          ))}
        </div>

        {/* Уровень 3 — дети выбранной подкатегории */}
        <div className="catpick-col">
          {(level3.length ? level3 : []).map((c) => (
            <button
              key={c.id}
              type="button"
              className="catpick-item"
              onClick={() => onLeafClick(c.id)}
              disabled={!subId}
            >
              <span className="catpick-name">{c.name}</span>
              <span className="catpick-arrow">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}